import { Button, FormControlLabel, IconButton, Switch } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import "./AddSupplier.scss";
import { MapContext } from "../map/MapContextProvider";
import { FileUpload } from "@mui/icons-material";
import UploadSupplier from "./UploadSupplier";

export default function AddSupplierComponent() {
    const webglRef = useRef();
    const { map} = useContext(MapContext);
    const [openSupplier, setOpenSupplier] = useState(false);


    useEffect(() => {
        map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
        map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(webglRef.current);
    }, []);

    const uploadSupplierOkHandler = () => {
        setOpenSupplier(false);
    };

    const uploadSupplierModelHandler = () => {
        setOpenSupplier(true);
    };

    return (
        <>
            <div className="overlay-supplier" ref={webglRef}>
                {/* <div className="toggle-3d">
                    <FormControlLabel
                        control={<Switch />}
                        label={'3D Drawing'}
                    />
                </div> */}
                <div className="drawing-tools">
                    
                    <Button onClick={uploadSupplierModelHandler} startIcon={<FileUpload/>} variant="excel">Load Supplier</Button>
                </div>
            </div>

            <UploadSupplier openDialog={openSupplier} onClickAction={uploadSupplierOkHandler} />
        </>
    );
}